module.exports = __webpack_public_path__ + "img/order.31de3c0b.png";